export const VOLUME_SLIDER_DEFAULT_DIALOG_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  background: 'transparent',
  borderRadius: '30px 30px 0 0',
  width: '100%',
  height: 'auto',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translateY(-100%)'
};

export const VOLUME_SLIDER_SIZE = {
  default: { cursorSize: 16, trackSize: 172 },
  medium: { cursorSize: 16, trackSize: 100 },
  small: { cursorSize: 12, trackSize: 70 }
};

export const VOLUME_BUTTON_SIZE = {
  extraSmall: { width: 16 },
  small: { width: 24 },
  medium: { width: 36 },
  'large+extraLarge': { width: 44 }
};
